module.exports = __webpack_public_path__ + "static/media/regal-rush-blue-bg-gold-400x240.fa8d3d6c.png";